import type { InvitationPreview, PageState } from "./types";

export function toPageState(preview: InvitationPreview | null): PageState {
  if (!preview) return { kind: "invalid" };

  switch (preview.status) {
    case "pending":
      return { kind: "valid", preview };
    case "expired":
      return { kind: "expired" };
    case "revoked":
    case "declined":
      // Folded together deliberately: the recipient gains nothing from
      // distinguishing "the Patient revoked this" from "someone else
      // declined it" — both are equally non-actionable for them, and
      // showing either the Patient's identity or the decliner's would
      // risk PHI-adjacent disclosure this page must never carry.
      return { kind: "revoked" };
    case "redeemed":
      return { kind: "already_used" };
    default:
      return { kind: "invalid" };
  }
}
